export default __webpack_public_path__ + "static/media/new_niyama_logo.df14bf0f.svg";